import type {
  ApplyRemoteLicenseInput,
  ApplyRemoteLicenseResult,
  GlobalLicenseIssueInput,
  GlobalLicenseListQuery,
  GlobalLicenseListResult,
  LicenseOperationResult,
  LicenseRevealInput,
  LicenseRevealResult,
} from '@quds/shared';
import { apiGet, apiPost } from '@/lib/api';

export const listGlobalLicenses = (query: GlobalLicenseListQuery = {}) =>
  apiGet<GlobalLicenseListResult>('/licenses', {
    limit: query.limit,
    cursor: query.cursor,
    deviceId: query.deviceId,
    q: query.q,
    product: query.product,
  });

export const issueGlobalLicense = (body: GlobalLicenseIssueInput) =>
  apiPost<LicenseOperationResult>('/licenses/issue', body);

export const revealGlobalLicense = (licenseId: string, body: LicenseRevealInput) =>
  apiPost<LicenseRevealResult>(`/licenses/${encodeURIComponent(licenseId)}/reveal`, body);

export const applyRemoteBusinessLicense = (businessId: string, body: ApplyRemoteLicenseInput) =>
  apiPost<ApplyRemoteLicenseResult>(`/businesses/${encodeURIComponent(businessId)}/licenses/apply-remote`, body);
